import { Icon } from "@/components/Icon";
import { Fragment } from "react";
import { createSlots, Slot } from "utils/create-slots";

const Widget = ({ data, children, onClick, isfinancable = true }) => {
  const [modalTrigger] = createSlots(["modalTrigger"], children);

  function getRateValue(car) {
    if (car.isfinanceable) {
      if (
        car.showNettoPreis &&
        car.financingdata?.response?.monthlyInstallmentTotalAmount?.netValue
      ) {
        return car.financingdata.response.monthlyInstallmentTotalAmount
          .netValue;
      }

      if (
        !car.showNettoPreis &&
        car.financingdata?.response?.monthlyInstallmentTotalAmount?.grossValue
      ) {
        return car.financingdata.response.monthlyInstallmentTotalAmount
          .grossValue;
      }
    }
    // When car is leasable and shownetto is true, return the net value of leasingdata
    if (
      car.isleasable &&
      car.showNettoPreis &&
      car.leasingdata?.response?.monthlyInstallment?.netValue
    ) {
      return car.leasingdata.response.monthlyInstallment.netValue;
    }

    // When car is leasable and shownetto is false, return the gross value of leasingdata
    if (
      car.isleasable &&
      !car.showNettoPreis &&
      car.leasingdata?.response?.monthlyInstallment?.grossValue
    ) {
      return car.leasingdata.response.monthlyInstallment.grossValue;
    }

    // When isleasing is false, get the data from financedata, because isfinanceable is true

    // If none of the conditions match, or the required data is missing, return a default message or value.
    return "No rate available";
  }

  return (
    <div
      className="fixed left-0 right-0 bottom-0 z-50 flex flex-nowrap"
      onClick={onClick}
    >
      <div className="md:shadow-md shadow-lg mx-auto  md:px-6 px-0 py-6 relative translate-y-0 flex-nowrap flex bg-white rounded-t-6 md:w-auto w-full justify-center ">
        {isfinancable ? (
          <Fragment>
            {/* <div className="bg-blue-light hover:bg-blue-medium transition-colors p-4 rounded-6 cursor-pointer block ">
              <Icon type={icon} className="w-8 h-8 text-white " />
            </div> */}
            <div className="flex  [ [&>div>div]:text-left lg:items-center ">
              <div className="pr-6  ">
                <div className="text-xs font-bold lg:pb-2 pb-3">
                  mtl. finanzieren
                </div>
                <div className="justify-start mt-1">
                  <span className="text-xs font-bold">ab </span>
                  <span className="text-3xl font-bold">
                    {getRateValue(data)} €
                  </span>
                </div>
              </div>
              <div className=" px-6 border-l-[1px] border-gray-300 ">
                <div className="text-xs font-bold  pb-4">Laufzeit</div>
                <span className="md:text-base text-sm font-bold">
                  36 Monate
                </span>
              </div>
              <div className=" px-6 border-l-[1px] border-gray-300 mr-5">
                <div className="text-xs font-bold pb-4">Topzins</div>
                <span className="md:text-base text-sm font-bold">
                  {data?.financingdata?.response?.effectiveInterestRate !==
                    undefined &&
                  data?.financingdata?.response?.effectiveInterestRate !== null
                    ? data.financingdata.response.effectiveInterestRate === 0
                      ? "0,00 %"
                      : `${data.financingdata.response.effectiveInterestRate} %`
                    : "3,99 %"}
                </span>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="flex  [ [&>div>div]:text-left lg:items-center ">
              {/* <div className="bg-blue-light hover:bg-blue-medium transition-colors p-4 rounded-6 cursor-pointer md:block hidden">
                <Icon type={icon} className="w-8 h-8 text-white " />
              </div> */}
              <div className="pr-6  ">
                <div className="text-xs font-bold lg:pb-0 pb-3">mtl.leasen</div>
                <span className="text-xs font-bold">ab </span>
                <span className="text-3xl font-bold">
                  {getRateValue(data)} €
                </span>
              </div>
              <div className=" px-6 border-r-[1px] border-l-[1px] border-gray-300 ">
                <div className="text-xs font-bold pb-3">Laufzeit</div>
                <span className="md:text-base text-sm font-bold">
                  30 Monate
                </span>
              </div>
              <div className="px-6 ">
                <div className="text-xs font-bold pb-3">Laufleistung</div>
                <span className="md:text-base text-xs font-bold">
                  25.000 km
                </span>
              </div>
              <div className=" px-6 border-l-[1px] border-gray-300 mr-5">
                <div className="text-xs font-bold pb-3">Topzins</div>
                <span className="md:text-base text-sm font-bold">
                  {data?.financingdata?.response?.effectiveInterestRate !==
                    undefined &&
                  data?.financingdata?.response?.effectiveInterestRate !== null
                    ? data.financingdata.response.effectiveInterestRate === 0
                      ? "0,00 %"
                      : `${data.financingdata.response.effectiveInterestRate} %`
                    : "3,99 %"}
                </span>
              </div>
            </div>
          </Fragment>
        )}
        <Slot name="modalTrigger">{modalTrigger}</Slot>
      </div>
    </div>
  );
};

const ModalTrigger = () => {
  return (
    <div className="bg-gray-300 hover:bg-gray-600 group transition-colors w-[50px] h-[50px]  p-5 rounded-full cursor-pointer">
      <Icon
        type="chevron"
        className="w-7 h-7 text-blue-light  rotate-[270deg] ml-1 group-hover:-translate-y-3"
      />
    </div>
  );
};

export default Object.assign(Widget, { ModalTrigger });
